import Pictogram from '../pictogram';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import TranslatedCopy from '../../../intl/translated-copy';
import cx from 'classnames';
import {
  func,
} from 'prop-types';
import ModalFormBilling from './modal-form-billing';
import BillingLoader from './modal-billing-loader';
import BillingFlowEnd from './modal-billing-flow-end';

import queryString from 'query-string';
import { getCheckInReservationAction, getSingleBillingAction } from '../../../../redux/actions';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getTripSFRedirect } from '../../../utilities/helpers';

const BillingModal = ({
  checkinReservation,
  dispatch,
  singleBilling,
  stampingBilling,
  storefront,
}) => {
  const modal = document.querySelector('#modal_portal');
  
  const [showContent, setShowContent] = useState('loading');
  const [creationDate, setCreationDate] = useState('');
  const [lastName, setLastName] = useState('');
  const [pnrCode, setPnrCode] = useState('');
  const [urlRedirect, setUrlRedirect] = useState(`/${storefront}${getTripSFRedirect(storefront)}/trips?`);

  const modalClasses = cx({
    'BillingModal-modal': true,
    'flowEndHeight': showContent !== 'form',
  });

  useEffect(() => {
    const urlParams = queryString.parse(location.search);
    dispatch(getCheckInReservationAction(urlParams.pnr, urlParams['last-name']));
    const htmlTag = document.getElementsByTagName('html')[0];
    htmlTag.classList.add('Modal-open--state');
    setPnrCode(urlParams['last-name']);
    setLastName(urlParams.pnr);
  }, []);

  useEffect(() => {
    const urlParams = queryString.parse(location.search);
    if (checkinReservation?.responseCheckInReservation?.transactionId !== null && checkinReservation?.responseCheckInReservation?.transactionId !== undefined) {
      dispatch(getSingleBillingAction(urlParams.pnr, checkinReservation?.responseCheckInReservation?.transactionId));
      setCreationDate(checkinReservation?.responseCheckInReservation?.creationDate);
    }

    const isLoading = checkinReservation?.loadingCheckInReservation;
    const thereIsAnError = checkinReservation?.errorReservation;

    if (checkinReservation?.responseCheckInReservation?.clid?.length > 0) {
      setUrlRedirect(`/${storefront}${getTripSFRedirect(storefront)}/trips?`);
    }

    if (thereIsAnError) {
      setShowContent('error');
    } else if (isLoading) {
      setShowContent('loading');
    }
  }, [checkinReservation]);

  useEffect(() => {
    const isLoading = singleBilling?.loadingSingleBilling;
    const thereIsAnError = singleBilling?.errorSingleBilling;
    const isExpired = singleBilling?.ticketBillingArray.some(ticket => {
      const oneDay = 24 * 60 * 60 * 1000;
      const dayDiff = Math.round(Math.abs((new Date() - new Date(creationDate)) / oneDay));
      if (dayDiff > 25) {
        return true;
      } else if (ticket?.fechaEmision === '' || ticket?.fechaEmision === undefined || ticket?.fechaEmision === null ) {
        return false;
      }
    });

    const someTicketsBillable = singleBilling?.ticketBillingArray.length > 0 && singleBilling?.ticketBillingArray.some(ticket => ticket?.isFacturable !== null && ticket?.isFacturable);
    const allTTicketsNotBillable = singleBilling?.ticketBillingArray.every(ticket => ticket?.isFacturable !== null && !ticket?.isFacturable);

    if (thereIsAnError) {
      setShowContent('error');
    } else if (isLoading) {
      setShowContent('loading');
    } else if (isExpired) {
      setShowContent('expired');
    } else if (someTicketsBillable) {
      setShowContent('form');
    } else if (allTTicketsNotBillable) {
      setShowContent('notBillable');
    }
  }, [singleBilling]);

  useEffect(() => {
    const isLoading = stampingBilling?.loadingStampingBilling;
    const thereIsAnError = stampingBilling?.errorStampingBilling;
    const stampingSuccessful = stampingBilling?.ticketStampingArray.length > 0 && stampingBilling?.ticketStampingArray.every(ticket => ticket?.eticket !== '');

    if (thereIsAnError) {
      setShowContent('error');
    } else if (isLoading) {
      setShowContent('loading');
    } else if (stampingSuccessful) {
      setShowContent('success');
    }
  }, [stampingBilling]);

  return (ReactDOM.createPortal(
    <div className='Modal'>
      <div className={ modalClasses }>
        <div className='BillingModal-header'>
          <div className='BillingModal-header-titleSection'>
            <Pictogram className='BillingModal-header-titleSection-icon' id='billingLogo' />
            <TranslatedCopy className='BillingModal-header-titleSection-title' copyID='MYB_TAX_DATA' />
          </div>
          <Link className='BillingModal-header-closeButton' to={ `${ urlRedirect }last-name=${ lastName }&pnr=${ pnrCode }` } >
            <Pictogram
              className='BillingModal-header-closeButton-icon'
              id='Close'
            />
          </Link>
        </div>
        { showContent === 'form' &&
          <ModalFormBilling/>
        }
        { showContent === 'loading' &&
          <BillingLoader loadingStampingBilling={ stampingBilling?.loadingStampingBilling } />
        }
        { (showContent === 'success' || showContent === 'error' || showContent === 'notBillable' || showContent === 'expired') &&
          <BillingFlowEnd version={ showContent }/>
        }
      </div>
    </div>,
    modal
  ));
};

BillingModal.propTypes = {
  dispatch: func,
};

const mapStateToProps = (state) => ({
  checkinReservation: state.checkinReservation,
  singleBilling: state.singleBilling,
  stampingBilling: state.stampingBilling,
  storefront: state.Manage.storefront,
});

export default connect(mapStateToProps)(BillingModal);
